// Notification chime used by the notification center.
let audioContext = null;

function audio() {
  if (!audioContext) {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (AudioCtx) audioContext = new AudioCtx();
  }
  return audioContext;
}

// Browsers keep audio muted until the page has had a click or a key press, so the first one switches it on.
function unlockSound() {
  try {
    const ctx = audio();
    if (ctx && ctx.state === "suspended") ctx.resume();
  } catch {}
}

if (typeof window !== "undefined") {
  ["pointerdown", "keydown"].forEach(name => window.addEventListener(name, unlockSound, { passive: true }));
}

/** Two-beep ascending notification chime via Web Audio API */
export function playNotificationSound() {
  try {
    const ctx = audio();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume();
    const beep = (freq, start, dur) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.35, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
      osc.start(start);
      osc.stop(start + dur);
    };
    beep(660, ctx.currentTime, 0.22);
    beep(880, ctx.currentTime + 0.28, 0.28);
  } catch {}
}
